import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class ModelUtils {

    public static deepclone (object: any): any {
        return JSON.parse(JSON.stringify(object))
    }
}
